import * as React from "react";
import { PhotoSwipe } from "react-photoswipe";
import * as styles from "./styles.css";
var PhotoGallery = function (_a) {
    var items = _a.items, options = _a.options, _b = _a.isOpen, isOpen = _b === void 0 ? false : _b, onClose = _a.onClose;
    return (React.createElement(PhotoSwipe, { className: styles.photoGallery, isOpen: isOpen, items: items, options: Object.assign({}, options, {
            counterEl: false,
            fullscreenEl: false,
            history: false,
            preloaderEl: false,
            shareEl: false,
            timeToIdle: 0,
            timeToIdleOutside: 0,
            zoomEl: false,
        }), onClose: onClose }));
};
export default PhotoGallery;



//////////////////
// WEBPACK FOOTER
// ./app/shared/components/photoGallery/photoGallery.tsx
// module id = Lxu2
// module chunks = 2